<template>
  <div class="avisosTopBarWrapper" :class="{ 'bg-light' : opened }" >
    <font-awesome-icon icon="user" :class="{'text-light': !opened, 'text-primary': opened}" class="avisosTopButton" @click="toggleUsuarioDropdown()"/>
    <div v-if="opened" class="dropdownAvisosTopBar bg-light border-left border-right border-bottom shadow">
      <p class="username border-bottom">{{ this.credentials.nombre }}</p>
      <ul>
        <li class="border-bottom">
          <router-link to="/yo" class="d-inline-block w-100 p-2" @click.native="opened = false"><font-awesome-icon icon="user"/> Mis datos</router-link>
        </li>
        <li class="border-bottom">
          <router-link to="/logout" class="d-inline-block w-100 p-2" @click.native="opened = false"><font-awesome-icon icon="sign-out-alt"/> Salir</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      opened: false
    }
  },
  computed: {
    ...mapGetters({
      avisosNuevos: 'avisosNuevos',
      credentials: 'credentials'
    })
  },
  methods: {
    toggleUsuarioDropdown() {
      this.opened = !this.opened
    }
  }
}
</script>

<style scoped>
.avisosTopBarWrapper {
  height: 45px; 
}
.avisosTopButton {
  padding-left: 10px; 
  padding-right: 10px; 
  height: 45px;
  width: 35px;
  display: inline-block;
  cursor: pointer;
}
.dropdownAvisosTopBar {
  position: absolute;
  width: 100%;
  max-width: 400px;
  right: 0;
  top: 40px;
  z-index: 2000;
  border-width: 2px!important;
}
.dropdownAvisosTopBar > ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.dropdownAvisosTopBar > ul > li {
  padding: 2px 10px 2px 10px;
  cursor: pointer;
}
.dropdownAvisosTopBar > ul > li:hover {
  background-color: #EEE;
}
.dropdownAvisosTopBar > ul > li > h3 {
  font-size: 1.3em;
  margin: 0;
}
.badge-avisos-topbar {
  border-radius: 10px!important; 
  position: absolute!important;
  margin-left: -15px!important;
  margin-top: 4px!important;
  padding-top: 2px!important;
  padding-bottom: 2px!important;
  padding-left: 4px!important;
  padding-right: 4px!important;
}
.username {
  padding: 10px 10px 10px 10px;
  text-align: center;
  margin-bottom: 0;
}
</style>

